import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import api from "../../api";
import useDynamicPageSize from "../../useDynamicPageSize";
import Footer from "../../Footer";
import { toast, ToastContainer } from "react-toastify";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { table } from "console";
import { page } from "../../core/common/selectoption/selectoption";


type DesignationType = {
  id: number;
  Designation: string;
};
type ModalMode = "add" | "edit";

const Designations: React.FC = () => {
  const { setFilters } = useHeaderFilters();
  // pagination & data
  const [currentPage, setCurrentPage] = useState(1);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const pageSize = useDynamicPageSize();
  const [totalItems, setTotalItems] = useState(0);
  const [designations, setDesignations] = useState<DesignationType[]>([]);
  const [loading, setLoading] = useState(true);
  // form state
  const [formData, setFormData] = useState({ Designation: "" });
  const [formError, setFormError] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [modalMode, setModalMode] = useState<ModalMode>("add");
  const isInitialFetch = useRef(true);

  useLayoutEffect(() => {
    if (pageSize === 0) return; // Prevent setting height too early
    const calculateHeight = () => {
      const baseOffset = 194;
      const extraOffset = window.innerWidth <= 991 ? -43 : -81;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log("Calculated table height:", newHeight);
      console.log("fixedOffset:", fixedOffset);
      console.log("window.innerHeight:", window.innerHeight);
      console.log("totalItems :", totalItems);
      console.log("pagesize :", pageSize);
      setTableHeight(newHeight);
    };
    calculateHeight();
  }, [pageSize]);

  // fetch
  const fetchDesignations = async () => {
    try {
      setLoading(true);
      const res = await api<{ data: any }>("/designations", {
        method: "POST",
        body: { currentPage, pageSize: pageSize },
      });
      const apiData = res.data;
      setDesignations(
        apiData.data.map((rec: any) => ({
          id: rec.id,
          Designation: rec.title,
        }))
      );
      setTotalItems(apiData.total);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchDesignations();
    console.log("Page size:", pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    const DesignationsFilters = () => (
      <div className="px-2 px-md-2">
        <div className="designation-filters d-flex align-items-center flex-wrap ">
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={() => openModal("add")}
            >
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
    );

    setFilters(<DesignationsFilters />);
    return () => {
      console.log("cleaning up filters");
      setFilters(null);
    };
  }, []);

  // open modal (add or edit)
  const openModal = (mode: ModalMode, rec?: DesignationType) => {
    setFormError("");
    setModalMode(mode);
    setFormData({ Designation: "" });
    setEditId(null);

    if (mode === "edit" && rec) {
      setFormData({ Designation: rec.Designation });
      setEditId(rec.id);
    }

    const el = document.getElementById("designation_modal");
    if (el) {
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    }
  };

  // hide modal + backdrop cleanup
  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el || !(window as any).bootstrap?.Modal) return;

    const instance = (window as any).bootstrap.Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }

    // after fade, remove any stray backdrops & body locks
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };
  const openDeleteModal = (id: number) => {
    setEditId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };
  // form handlers
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val.trim()) setFormError("");
    setFormData({ Designation: val });
  };

 const handleSubmit = async () => {
  if (!formData.Designation.trim()) {
    setFormError("Designation title is required.");
    return;
  }
  try {
    const body: any = { title: formData.Designation.trim() };
    if (modalMode === "edit" && editId != null) body.id = editId;

    const res = await api<{ success: boolean; error?: string }>(
      "/designations/savedesignation",
      { method: "POST", body }
    );

    if (res.success) {
      if (modalMode === "edit") {
        await fetchDesignations();
      } else {
        // For add mode:
        setTotalItems((prevCount) => {
                const newCount = prevCount + 1;
                setCurrentPage(1);
                fetchDesignations();
                return newCount;
          });
      }

      hideModal("designation_modal");
      toast.success(
        modalMode === "add"
          ? "Designation added successfully!"
          : "Designation updated successfully!"
      );
    } else {
      const msg = res.error?.toLowerCase().includes("duplicate")
        ? "Duplicate title! Designation already exists."
        : res.error || "Failed to save designation.";
      toast.error(msg);
    }
  } catch (err: any) {
    if (err.response?.data) {
      const data = err.response.data;
      const msg =
        data.error ||
        data.message ||
        err.message ||
        "Something went wrong.";
      toast.error(msg);
    } else {
      toast.error(err.message || "Something went wrong.");
    }
  }
};


  const handleDelete = async (id: number) => {
  try {
    const res = await api<{ success: boolean; error?: string }>(
      `/designations/${id}`,
      { method: "DELETE" }
    );

    if (res.success) {
      setDesignations((prev) => prev.filter((d) => d.id !== id));
      setTotalItems((prevCount) => prevCount - 1);
      toast.success("Designation deleted successfully!");

      // Calculate the total pages after deletion
      const totalPages = Math.ceil((totalItems - 1) / pageSize);
      // If the current page number is now greater than totalPages, move back one page
      if (currentPage > totalPages) {
        setCurrentPage(totalPages > 0 ? totalPages : 1);
      } else {
        fetchDesignations();
      }
    } else {
      toast.error(res.error || "Failed to delete designation.");
    }
  } catch (err: any) {
    if (err.response?.data) {
      const data = err.response.data;
      const msg =
        data.error ||
        data.message ||
        err.message ||
        "Something went wrong.";
      toast.error(msg);
    } else {
      toast.error(err.message || "Something went wrong.");
    }
  }
};


  // table columns
  const columns = [
    {
      title: "Title",
      dataIndex: "Designation",
      width: "70%",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, rec: DesignationType) => (
        <div className="action-icon d-inline-flex">
          <Link to="#" onClick={() => openModal("edit", rec)}>
            <i className="ti ti-edit" />
          </Link>
          <Link to="#" onClick={() => openDeleteModal(rec.id)}>
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
    <div className="page-wrapper d-flex flex-column">
      <div className="content flex-grow-1">
        {/* <div className="d-flex justify-content-end align-items-center mb-3"> */}
        {/* <button className="btn btn-primary" onClick={() => openModal('add')}>
		  		<i className="ti ti-circle-plus" />
          </button> */}
        {/* </div> */}
        <div className="card card-margin-bottom">
          <div
            className="card-body p-0"
            id="Designation-list"
            style={{
              height: tableHeight,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Table
              style={{ flex: 1 }}
              currentPage={currentPage}
              dataSource={designations}
              columns={columns}
              onPageChange={setCurrentPage}
              totalItems={totalItems}
              pageSize={pageSize}
              loading={loading}
            />
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      <div className="modal fade" id="designation_modal">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {modalMode === "add" ? "Add Designation" : "Edit Designation"}
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => hideModal("designation_modal")}
              />
            </div>
            <div className="modal-body pb-0">
              <div className="mb-3">
                <label className="form-label">Designation Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="Designation"
                  onChange={handleInputChange}
                  value={formData.Designation}
                />
                {formError && (
                  <small className="text-danger">{formError}</small>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-light me-2"
                onClick={() => hideModal("designation_modal")}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {modalMode === "add" ? "Add" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div id="top-modal" className="modal fade" tabIndex={-1}>
        <div className="modal-dialog modal-top">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Delete</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cancel" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => editId !== null && handleDelete(editId)}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <ToastContainer position="top-right" autoClose={3000} /> </>
  );
};

export default Designations;
